import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer } from "@fleet/ui";
import { TrashView } from "@/features/trash/components/trash-view";

function TrashRoutePage() {
  // No auth gate: the trash is local-first and also works for
  // guests (their soft deletes live in local SQLite).
  return (
    <PageContainer maxWidth="3xl">
      <TrashView />
    </PageContainer>
  );
}

export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: TrashRoutePage,
});
